// removed by extract-text-webpack-plugin
module.exports = {"heading":"heading__3tysZ","xs":"xs__2-Spr","sm":"sm__1kN-G","md":"md__3n-J3","lg":"lg__uCPk2","xl":"xl__3eFGf"};


//////////////////
// WEBPACK FOOTER
// ./components/typography/heading/style.css
// module id = W4AX
// module chunks = 3